import Vue from 'vue';
import axios from 'axios';
import i18n from '@/locale/i18n';
import { API_BASE_URL } from './constants';

// axios 配置、
axios.defaults.withCredentials = true;
axios.defaults.timeout = 30000;
axios.defaults.baseURL = API_BASE_URL; //process.env.VUE_APP_SERVER === 'yf' ? '//beta-asset-api.shop.jd.com' : '//asset-api.shop.jd.com';
Vue.prototype.axios = axios;

// http response 拦截器
axios.interceptors.request.use(
    (config) => {
        return config;
    },
    (error) => {
        Vue.prototype.$notify.warning({
            title: i18n.t('w112'),
            message: i18n.t('w113'),
        });
        return Promise.reject(error);
    }
);

// 添加响应拦截
axios.interceptors.response.use(
    (res) => {
        if (res.data.code == '20001' || res.data.code == '1001') {
            //权益账户未登录
            window.location.href =
                '//passport.shop.jd.com/nologin/login.action?ReturnUrl=' +
                encodeURIComponent(location.href);
            return Promise.reject();
        } else if (res.data.code === 1012) {
            //账户安全验证
            const url = res.data.redirectUrl.split('ReturnUrl=');
            window.location.href = url[0] + 'ReturnUrl=' + encodeURIComponent(location.href);
            return Promise.reject();
        } else if (
            res.data.code == '602' ||
            res.data.code == '601' ||
            res.data.code == '400001009'
        ) {
            //权益账户未签约：602
            window.location.hash = '#/serviceProtocal/' + JSON.parse(res.config.data).typeId;
            return Promise.reject();
        } else if (res.data.code == '400023009') {
            // 红包 该充值订单已开具线下邮寄的增值税专票，请前往订单详情完成线下邮寄发票冲红后再提交退款申请
            return Promise.reject('400023009');
        } else if (res.data.code != '200') {
            Vue.prototype.$notify.warning({
                title: i18n.t('w112'),
                message: res.data.message,
            });
            return Promise.reject(res.data);
        } else {
            return res;
        }
    },
    (error) => {
        return Promise.reject(error);
    }
);
